import Phaser from 'phaser';

import { BootScene } from '@/features/laneChooserPhaser/game/scenes/BootScene';
import { LaneChooserThemeScene } from '@/features/laneChooserPhaser/game/scenes/LaneChooserThemeScene';

import type { LaneChooserEventBus } from '@/features/laneChooserPhaser/game/EventBus';
import type { LaneChooserGameTheme } from '@/features/laneChooserPhaser/game/types';

export function createGameConfig(
	parent: HTMLElement,
	eventBus: LaneChooserEventBus,
	themeConfig: LaneChooserGameTheme,
): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = window.devicePixelRatio || 1;

	return {
		type: Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || 800) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || 600) * devicePixelRatio)),
		backgroundColor: '#ddfcff',
		scene: [new BootScene(themeConfig), new LaneChooserThemeScene(eventBus, themeConfig)],
		dom: {
			createContainer: true,
		},
		scale: {
			mode: Phaser.Scale.NONE,
		},
		antialias: true,
		roundPixels: true,
	};
}
